import React from 'react';
import ResponsibleForm from '../../../components/forms/ResponsibleForm';

export default function ResponsibleCreatePage() {
  return <ResponsibleForm />;
}
